export default function Contact() {
  return (
    <div className="text-sm">
      <h4 className="font-semibold mb-1">Contact</h4>
      <p className="mb-0">
        For help or questions, email us at
        {' '}
        <a href="mailto:support@unchanged.fyi" aria-label="Email support at support@unchanged.fyi" className="text-blue-600 underline">support@unchanged.fyi</a>
        .
      </p>
    </div>
  );
}
